import {
    faHandsHelping,
    faConciergeBell,
    faDollarSign,
    faBuilding,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";
import { useUserInfor } from "../../../../../Context/User";
import { ACESSOS } from "../../../../../Routes/Acessos";
import { mostrarNavDeTela } from "../../../../../Validations/UsuarioTela";

interface ISubNavProdutosProps {}

export default function SubNavProdutos(props: ISubNavProdutosProps) {
    const { UserInfor } = useUserInfor();

    return (
        <>
            {UserInfor.TELAS
                ? UserInfor.TELAS.map((tela) => {
                      if (tela.ID_TELA === 552) {
                          return (
                              <li key={tela.ID_TELA} className="menu-item">
                                  <NavLink
                                      to={
                                          ACESSOS.VENDAS.TELAS.GESTAO_RESERVAS
                                              .DS_PATH
                                      }
                                      exact
                                      activeClassName="active"
                                      className="menu-link"
                                      onClick={() => {}}
                                  >
                                      <span className="svg-icon menu-icon">
                                          <FontAwesomeIcon
                                              icon={faHandsHelping}
                                          />
                                      </span>
                                      <span className="menu-text">
                                          Gestão de Reservas
                                      </span>
                                  </NavLink>
                              </li>
                          );
                      } else return <div key={tela.ID_TELA}></div>;
                  })
                : null}

            {UserInfor.TELAS
                ? UserInfor.TELAS.map((tela) => {
                      if (tela.ID_TELA === 551) {
                          return (
                              <li key={tela.ID_TELA} className="menu-item">
                                  <NavLink
                                      to={
                                          ACESSOS.VENDAS.TELAS.GESTAO_VISITAS
                                              .DS_PATH
                                      }
                                      exact
                                      activeClassName="active"
                                      className="menu-link"
                                      onClick={() => {}}
                                  >
                                      <span className="svg-icon menu-icon">
                                          <FontAwesomeIcon
                                              icon={faConciergeBell}
                                          />
                                      </span>
                                      <span className="menu-text">
                                          Gestão de Visitas
                                      </span>
                                  </NavLink>
                              </li>
                          );
                      } else return <div key={tela.ID_TELA}></div>;
                  })
                : null}

            {mostrarNavDeTela(
                ACESSOS.VENDAS.TELAS.ANALISE_CREDITO.ID_TELA,
                UserInfor.TELAS
            ) && (
                <li className="menu-item">
                    <NavLink
                        to={ACESSOS.VENDAS.TELAS.ANALISE_CREDITO.DS_PATH}
                        exact
                        activeClassName="active"
                        className="menu-link"
                    >
                        <span className="svg-icon menu-icon">
                            <FontAwesomeIcon icon={faDollarSign} />
                        </span>
                        <span className="menu-text">
                            Gestão de Análise de Crédito
                        </span>
                    </NavLink>
                </li>
            )}

            {mostrarNavDeTela(
                ACESSOS.VENDAS.TELAS.GESTAO_PRODUTOS.ID_TELA,
                UserInfor.TELAS
            ) && (
                <li className="menu-item">
                    <NavLink
                        to={ACESSOS.VENDAS.TELAS.GESTAO_PRODUTOS.DS_PATH}
                        exact
                        activeClassName="active"
                        className="menu-link"
                    >
                        <span className="svg-icon menu-icon">
                            <FontAwesomeIcon icon={faBuilding} />
                        </span>
                        <span className="menu-text">Gestão de Produtos</span>
                    </NavLink>
                </li>
            )}
        </>
    );
}
